import { render, staticRenderFns } from "./orgStep2.vue?vue&type=template&id=48b787e0&scoped=true"
import script from "./orgStep2.vue?vue&type=script&lang=js"
export * from "./orgStep2.vue?vue&type=script&lang=js"
import style0 from "./orgStep2.vue?vue&type=style&index=0&id=48b787e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b787e0",
  null
  
)

export default component.exports